<script setup lang="ts">


</script>

<template>


  <h1>Formulaires disponibles</h1>

  <br />


  <ul>
      <!--en commentaire les formulaire pas encore fini-->
      <li>
          <RouterLink to="/cellules-souches">Formulaire cellules souches</RouterLink>
      </li>
      <li>
          <RouterLink to="/commmande-cordon">Formulaire de commande de matériel pour le sang de cordon</RouterLink>
      </li>
      <li>
          <RouterLink to="/adresse">Formulaire de changement adresse</RouterLink>
      </li>
      <li>
          <RouterLink to="/demande-renseignements">Formulaire de demande de renseignements</RouterLink>
      </li>
      <li>
          <RouterLink to="/Suivi-PosteGreffe">Formulaire de Suivi Post-Greffe Autologue</RouterLink>
      </li>
      <li>
          <RouterLink to="/liste-suivi-posteGreffe">Liste des formulaires de Suivi Post-Greffe Autologue CH</RouterLink>
      </li>
      <li>
          <RouterLink to="/educationhq">Formulaire Éducation HQ</RouterLink>
      </li>
      <li>
          <RouterLink to="/benevoles">Formulaire Bénévoles</RouterLink>
      </li>
      <li>
          <RouterLink to="/recherche">Formulaire Recherche</RouterLink>
      </li>
      <li>
          <RouterLink to="/lait-maternel">Formulaire d'inscription à la banque publique de lait maternel</RouterLink>
      </li>
      <li>
          <RouterLink to="/sang-cordon">Formulaire d'inscription à la Banque publique de sang de cordon</RouterLink>
      </li>
  </ul>



</template>
